import styled from 'styled-components';

import { useWindowSize } from 'shared/hooks/useWindowSize';
import { breakpoints } from 'styles/theme/breakpoints';
import { variableFontRegular } from 'styles/theme/text';

import { Image } from 'shared/components/Image';
import { DownloadCta } from 'appLanding/components/DownloadCta';
import { t } from 'localization/utils/t';
import { HERO_IMG_LG, HERO_IMG_SM } from '../enums/appLandingPageEnums';

const TP = 'appLanding.components.KeyFreatures';

export const KeyFeatures = () => {
  const { windowSize } = useWindowSize();
  const isMinWidthMedium = windowSize.width > breakpoints.medium;

  return (
    <KeyFeatures.Content>
      <KeyFeatures.HeroImageContainer>
        <Image
          alt={t(`${TP}.HeroImageAlt`, 'Mobile devices demoing the GOAT app.')}
          data-qa="key_features_hero_image"
          src={isMinWidthMedium ? HERO_IMG_LG : HERO_IMG_SM}
          sizes={isMinWidthMedium ? '100%' : '80%'}
        />
      </KeyFeatures.HeroImageContainer>
      <KeyFeatures.Features>
        <KeyFeatures.FeaturesList>
          <KeyFeatures.FeaturesListItem>
            {t(`${TP}.feature1`, 'Shop sneakers, apparel and accessories')}
          </KeyFeatures.FeaturesListItem>
          <KeyFeatures.FeaturesListItem>
            {t(`${TP}.feature2`, 'Get notifications on price drops')}
          </KeyFeatures.FeaturesListItem>
          <KeyFeatures.FeaturesListItem>
            {t(`${TP}.feature3`, 'Make offers on your most-wanted styles')}
          </KeyFeatures.FeaturesListItem>
          <KeyFeatures.FeaturesListItem>
            {t(`${TP}.feature4`, 'Try on coveted sneaker styles with AR')}
          </KeyFeatures.FeaturesListItem>
          <KeyFeatures.FeaturesListItem>
            {t(`${TP}.feature5`, 'Access exclusive drops and collections')}
          </KeyFeatures.FeaturesListItem>
        </KeyFeatures.FeaturesList>
        <DownloadCta />
      </KeyFeatures.Features>
    </KeyFeatures.Content>
  );
};

KeyFeatures.Content = styled.div`
  margin-bottom: 160px;
  padding: 20px;
  @media (min-width: ${({ theme }) => theme.breakpoints.medium}px) {
    display: flex;
    justify-content: center;
  }
`;
KeyFeatures.HeroImageContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  overflow: hidden;
  margin: 0 -20px;
  > div {
    width: 100%;
  }
  @media (min-width: ${({ theme }) => theme.breakpoints.medium}px) {
    width: 60%;
    margin: 0;
  }
`;
KeyFeatures.Features = styled.div`
  color: ${({ theme }) => theme.colors.black};
  padding: 30px 0;

  @media (min-width: ${({ theme }) => theme.breakpoints.medium}px) {
    display: flex;
    flex-direction: column;
    justify-content: flex-end;
    width: 40%;
    max-width: 308px;
  }
`;
KeyFeatures.Heading = styled.h1`
  font-size: 24px;
  margin: 0 0 35px;
  text-transform: capitalize;
  @media (min-width: ${({ theme }) => theme.breakpoints.medium}px) {
    font-size: 32px;
    margin: 0 0 70px;
  }
`;
KeyFeatures.FeaturesList = styled.ul`
  font-size: 16px;
  margin: 0;
  padding: 0;
  list-style: none;
  @media (min-width: ${({ theme }) => theme.breakpoints.medium}px) {
    font-size: 18px;
  }
`;
KeyFeatures.FeaturesListItem = styled.li`
  margin-bottom: 12px;
  ${variableFontRegular({ size: '11.5px', height: '14px' })};
`;
